import {Keyword} from '../models/keyword';
import {useLanguageIndependentData} from './useLanguageIndependentData.hook';

export const useKeywords =
    useLanguageIndependentData<Keyword[]>('keywords');


